import { Box, BoxProps } from '@jfs/ui-new'
import { useFocusEffect, useRoute } from '@react-navigation/native'
import React, { useCallback, useRef, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../../components/Container'
import { NewTable } from '../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../data/store'
import { FraudAndRiskHeader } from '../FraudAndRiskHeader'
import { HoldTransactionsModal } from '../HoldTransactionsModal'

export const GenericHoldScreen = () => {
  const { resetPagination, fetchGroupByRiskTnxAsync, groupedRiskTnsx } = useStores((store) => ({
    resetPagination: store?.resetPagination,
    fetchGroupByRiskTnxAsync: store.riskConfig.fetchGroupByRiskTnxAsync,
    groupedRiskTnsx: store.riskConfig.getGroupedTnxsList(),
  }))

  const TYPE = (useRoute()?.params as any)?.type
  const { width }: any = useWindowDimensions()
  const [mid, setSelectedMid] = useState('')
  const [tableWidth, setTableWidth] = React.useState(width)

  const [holdTransactionsModalInfo, setHoldTransactionsModalInfo] = useState({ show: false })

  const [lazyFetchGroupByRiskTnx, fetchGroupByRiskTnxHandler] = useLazyApiData(fetchGroupByRiskTnxAsync)

  const abortControllerRef = useRef<AbortController>()

  const fetchGroupByRiskTnx = useCallback(() => {
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    console.log('mid', mid)
    lazyFetchGroupByRiskTnx(TYPE, mid, abortControllerRef?.current)
  }, [TYPE, lazyFetchGroupByRiskTnx, mid])

  const onMidChange = useCallback((updatedMid: any) => {
    setSelectedMid(updatedMid)
  }, [])

  useFocusEffect(
    useCallback(() => {
      resetPagination()
      fetchGroupByRiskTnx()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mid]),
  )

  const onSearchByMidClick = (mid: any) => {
    console.log('setSelectedMid', mid)
    setSelectedMid(mid)
    resetPagination()
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    console.log('mid', mid)
    lazyFetchGroupByRiskTnx(TYPE, mid, abortControllerRef?.current)
  }

  const onDismiss = useCallback(
    () => setHoldTransactionsModalInfo({ ...holdTransactionsModalInfo, show: false }),
    [holdTransactionsModalInfo],
  )

  const onRowClick = useCallback((data: any) => {
    setHoldTransactionsModalInfo({ ...data, show: true })
  }, [])

  return (
    <Box {...styles.container}>
      <FraudAndRiskHeader
        type={TYPE}
        fetchDataOnChange={fetchGroupByRiskTnx}
        showSearchBy={false}
        showSearchByMid={true}
        onSearchByMidClick={onSearchByMidClick}
        initialSearchMid={mid}
        maxRange={180}
        onMidChange={onMidChange}
      />
      <Container
        isLoading={fetchGroupByRiskTnxHandler.state === 'pending'}
        errorMessage={fetchGroupByRiskTnxHandler?.data?.message}
        paddingTop={16}
        onLayout={({ nativeEvent: { layout } }) => {
          setTableWidth(layout?.width)
        }}
        flex={1}
        nativeID="vertical-scroll"
        onRetry={fetchGroupByRiskTnx}>
        <NewTable
          data={groupedRiskTnsx}
          rowHeight={48}
          headerHeight={64}
          tableWidth={width > 1200 ? tableWidth : width}
          headerRowKeys={headerTitles(TYPE)}
          onRowClick={onRowClick}
        />
      </Container>
      {holdTransactionsModalInfo?.show && (
        <HoldTransactionsModal
          show={holdTransactionsModalInfo?.show}
          onDismiss={onDismiss}
          merchantDetail={holdTransactionsModalInfo}
          type={TYPE}
        />
      )}
    </Box>
  )
}
const headerTitles = (TYPE: any) => ({
  created: 'Date',
  merchantId: 'MID',
  // businessName: 'Businees Name',
  settlementNetAmount: TYPE === 'PAYOUT_STAGED' ? 'Total Amount' : 'Hold Amount',
  totalCount: TYPE === 'PAYOUT_STAGED' ? 'Total Count' : 'Hold Count',
})

const styles = {
  container: {
    height: '100%',
    backgroundColor: 'WHITE',
    borderWidth: 1,
    ph: 16,
    pv: 24,
    borderColor: 'GREY_SEPARATOR',
  } as BoxProps,
}
